const DEFAULT_TRIAL_ELIGIBILITY_MAX_AGE_MS = 15 * 60 * 1000;

export function getStoredTrialEligibility(maxAgeMs = DEFAULT_TRIAL_ELIGIBILITY_MAX_AGE_MS) {
  try {
    const checkedAt = Number(localStorage.getItem("trialEligibilityCheckedAt") || 0);
    const isFresh = checkedAt > 0 && Date.now() - checkedAt < maxAgeMs;
    return {
      isFresh,
      trialDays: isFresh ? Math.max(0, Number(localStorage.getItem("trialDays") || 0)) : 0,
    };
  } catch (_error) {
    return { isFresh: false, trialDays: 0 };
  }
}
